import { Component, Input } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslatePipe } from '@ngx-translate/core';

import { SkillSelectComponent } from '../../consultant/projects/skill-select/skill-select.component';
import { IFaehigkeit } from '../../../shared/model/faehigkeit.model';
import { CvTaskDraft } from '../cv-import-review.model';
import { INPUT_LIMITS } from '../../../shared/constants/input-limits';

/**
 * Review-field editor for a project's tasks (Aufgaben). Lenient: no field is
 * required; only max-lengths mirror the backend caps. Every edit writes back
 * through control.setValue (so the FormControl stays the source of truth and
 * emits valueChanges); per-task skills reuse the shared skill picker.
 */
@Component({
  selector: 'app-cv-tasks-field',
  templateUrl: './cv-tasks-field.component.html',
  styleUrl: './cv-tasks-field.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButton,
    MatIcon,
    MatExpansionModule,
    TranslatePipe,
    SkillSelectComponent,
  ],
})
export class CvTasksFieldComponent {
  @Input() control!: FormControl;
  @Input() skillList: IFaehigkeit[] = [];

  // Zuweisung im Konstruktor: im gebuendelten Testlauf laedt der Runner die geteilte
  // Konstanten-Datei verzoegert, ein Feld-Initialisierer liest sie dann als undefined.
  protected readonly limits: typeof INPUT_LIMITS;

  constructor() {
    this.limits = INPUT_LIMITS;
  }

  get tasks(): CvTaskDraft[] {
    return (this.control.value as CvTaskDraft[]) ?? [];
  }

  addTask(): void {
    this.control.setValue([
      ...this.tasks,
      { caption: '', details: '', skills: [] },
    ]);
  }

  removeTask(index: number): void {
    const next = [...this.tasks];
    next.splice(index, 1);
    this.control.setValue(next);
  }

  onCaptionChange(index: number, caption: string): void {
    this.patchTask(index, { caption });
  }

  onDetailsChange(index: number, details: string): void {
    this.patchTask(index, { details });
  }

  onSkillsChange(index: number, skills: IFaehigkeit[] | string[]): void {
    this.patchTask(index, { skills: [...(skills as IFaehigkeit[])] });
  }

  private patchTask(index: number, patch: Partial<CvTaskDraft>): void {
    const next = [...this.tasks];
    next[index] = { ...next[index], ...patch };
    this.control.setValue(next);
  }
}
